import { can, canAny, canAll } from '@/utils/access'

const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  accessReady: state => state.access.status === 'ready' && Boolean(state.access.snapshot),
  accessRuleVersion: state => state.access.snapshot ? state.access.snapshot.rule_version : 0,
  actionCodes: state => state.access.snapshot ? state.access.snapshot.action_codes : [],
  can: (state, getters) => action => getters.accessReady && can(getters.actionCodes, action),
  canAny: (state, getters) => actions => getters.accessReady && canAny(getters.actionCodes, actions),
  canAll: (state, getters) => actions => getters.accessReady && canAll(getters.actionCodes, actions)
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js